const wrapperMngt = {
    namespaced: true,
    state : {
        wrapperCd : '',
        wrapperNm : '',
        wrapperClass : '',
        status : ''
    },
    getters: {
        getWrapperCd (state) {
            return state.wrapperCd
        },
        getWrapperNm (state) {
            return state.wrapperNm
        },
        getWrapperClass (state) {
            return state.wrapperClass
        },
        getStatus (state) {
            return state.status
        }

    },
    mutations: {
        setWrapperCd (state, payload) {
            state.wrapperCd = payload
        },
        setWrapperNm (state, payload) {
            state.wrapperNm = payload
        },
        setWrapperClass (state, payload) {
            state.wrapperClass = payload
        },
        setStatus (state, payload) {
            state.status = payload
        },


    },
    actions: {
        setWrapperCd ({commit}, payload) {
            commit('setWrapperCd', payload)
        },
        setWrapperNm ({commit}, payload) {
            commit('setWrapperNm', payload)
        },
        setWrapperClass ({commit}, payload) {
            commit('setWrapperClass', payload)
        },
        setStatus ({commit}, payload) {
            commit('setStatus', payload)
        },
        setWrapperMngtinit ({commit}) {
            commit('setWrapperCd','');
            commit('setWrapperNm','');
            commit('setWrapperClass','');
            commit('setStatus','');
        },
    }
}


export default wrapperMngt